import { createContext, useContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import Slide from "@mui/material/Slide";

import TokenService from "../../services/token.service";

const AppContext = createContext();

const TransitionDown = (props) => {
    return <Slide {...props} direction="down" />;
};

export const AppProvider = ({ children }) => {
    const { enqueueSnackbar } = useSnackbar();

    const [reslyConfig, setReslyConfig] = useState(
        TokenService.getReslyConfig()
    );
    const [platform, setPlatform] = useState(TokenService.getPlatform());
    const [projectKey, setProjectKey] = useState(TokenService.getProjectId());
    const [notificationMessage, setNotificationMessage] = useState(null);
    const [authTokens, setAuthTokens] = useState(null);
    const [apiReady, setApiReady] = useState(false);

    useEffect(() => {
        if (notificationMessage) {
            enqueueSnackbar(notificationMessage.message, {
                variant: notificationMessage.type,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                },
                TransitionComponent: TransitionDown,
                autoHideDuration: notificationMessage.duration || 1500,
            });
        }
    }, [notificationMessage, enqueueSnackbar]);

    useEffect(() => {
        if (reslyConfig) {
            TokenService.setReslyConfig(reslyConfig);
        } else {
            setReslyConfig({});
        }
    }, [reslyConfig]);

    let providerValue = {
        platform,
        setPlatform,
        projectKey,
        setProjectKey,
        authTokens,
        setAuthTokens,
        setNotificationMessage,
        reslyConfig,
        setReslyConfig,
        apiReady,
        setApiReady,
    };

    return (
        <AppContext.Provider value={providerValue}>
            {children}
        </AppContext.Provider>
    );
};

const useAppContext = () => {
    return useContext(AppContext);
};

export { useAppContext };
